import { MAX_DISBURSEMENT_QUERY_AMOUNT } from "../util/EfupUtility";

export function validateAmountRange(startAmount, endAmount) {
    var validationErrors = '';

    if (!startAmount) {
        validationErrors = "Amount required";
    } else if (parseFloat(startAmount) > MAX_DISBURSEMENT_QUERY_AMOUNT || parseFloat(endAmount) > MAX_DISBURSEMENT_QUERY_AMOUNT) {
        validationErrors = "Amounts cannot exceed 14 digits";
    } else if (endAmount && (parseFloat(startAmount) > parseFloat(endAmount))) {
        validationErrors = "End amount must be greater than start amount";
    } else if (parseFloat(startAmount) < 0 || parseFloat(endAmount) < 0) {
        validationErrors = "Amounts must be greater than 0";
    }

    return validationErrors;
}